/**
 * Audit label helpers — humanise any action / entity_type value the backend records (existing,
 * backup/restore, or future) into a clean Title-Case label, and pick a sensible badge colour by
 * intent. Keeps the audit UI resilient: an unrecognised value still renders nicely, never raw.
 */

import type { BadgeVariant } from '../../../components/ui';

/** "plan_created" / "restore_initiated" / "CREATE" → "Plan Created" / "Restore Initiated" / "Create". */
export function humanizeAuditLabel(value: string): string {
  if (!value) return '';
  return value
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toLowerCase()
    .split(' ')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

/** Colour an action badge by intent — works for any action string, not a fixed enum. */
export function actionBadgeVariant(action: string): BadgeVariant {
  const a = (action || '').toLowerCase();
  if (/(delete|deleted|cancel|cancelled|purge|remove)/.test(a)) return 'error';
  if (/(restore|recover)/.test(a)) return 'warning';
  if (/(create|created|trigger|triggered|initiated|grant|granted|activate|activated)/.test(a)) return 'success';
  if (/(pause|paused|disable|disabled|archive|archived)/.test(a)) return 'warning';
  if (/(update|updated|change|changed|materialize|materialized|reassign|reassigned|assign|assigned)/.test(a)) return 'info';
  return 'default';
}
